import type {
  CreateOperationalZoneInput,
  OperationalZone,
  UpdateOperationalZoneInput,
} from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/**
 * Gestion des zones opérationnelles (ADR-0040, C5) depuis l'IHM : création et mise à jour (recentrage,
 * armement de la simulation). Écriture réservée EDITOR+ côté API ; l'IHM masque les contrôles aux autres.
 */

export function createZone(body: CreateOperationalZoneInput): Promise<OperationalZone> {
  return apiFetch<OperationalZone>('/ops/zones', { method: 'POST', body });
}

export function updateZone(
  zoneId: string,
  body: UpdateOperationalZoneInput,
): Promise<OperationalZone> {
  return apiFetch<OperationalZone>(`/ops/zones/${zoneId}`, { method: 'PATCH', body });
}
